import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import IShift from '@/models/Shifts/IShift';
import ShiftStatus from '@/models/Shifts/ShiftStatus';

export default class ShiftDto extends BaseAgencyScopeEntityDto implements IShift {
    status: ShiftStatus;
    bookingRoleId: string;
    bookingDateId: string;
    startAt: Date;
    endAt: Date;
    quantity: number;
    break: number;
    isPaidBreak: boolean;
    timesheets: TimesheetDto[] = [];
}